<template>
  <Teleport defer to="#app-context-rail-target">
    <slot />
  </Teleport>
</template>
